export default [
  {
    "label": "country-AFG",
    "alpha3": "AFG",
    "name": "Afghanistan",
    "salesForceId": "Afghanistan",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-ALB",
    "alpha3": "ALB",
    "name": "Albania",
    "salesForceId": "Albania",
    "frontline": "kdi-distributors",
    "regionCode": "EU"
  },
  {
    "label": "country-DZA",
    "alpha3": "DZA",
    "name": "Algeria",
    "salesForceId": "Algeria",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-AND",
    "alpha3": "AND",
    "name": "Andorra",
    "salesForceId": "Andorra"
  },
  {
    "label": "country-AGO",
    "alpha3": "AGO",
    "name": "Angola",
    "salesForceId": "Angola",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-AIA",
    "alpha3": "AIA",
    "name": "Anguilla",
    "salesForceId": "Anguilla",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-ATG",
    "alpha3": "ATG",
    "name": "Antigua and Deps",
    "salesForceId": "Antigua/Barbuda",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-ARG",
    "alpha3": "ARG",
    "name": "Argentina",
    "salesForceId": "Argentina",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-ARM",
    "alpha3": "ARM",
    "name": "Armenia",
    "salesForceId": "Armenia",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-ABW",
    "alpha3": "ABW",
    "name": "Aruba",
    "salesForceId": "Aruba",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-AUS",
    "alpha3": "AUS",
    "name": "Australia",
    "salesForceId": "Australia",
    "regionCode": "OC"
  },
  {
    "label": "country-AUT",
    "alpha3": "AUT",
    "name": "Austria",
    "salesForceId": "Austria",
    "regionCode": "EU"
  },
  {
    "label": "country-AZE",
    "alpha3": "AZE",
    "name": "Azerbaijan",
    "salesForceId": "Azerbaijan",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-BHS",
    "alpha3": "BHS",
    "name": "Bahamas",
    "salesForceId": "Bahamas"
  },
  {
    "label": "country-BHR",
    "alpha3": "BHR",
    "name": "Bahrain",
    "salesForceId": "Bahrain",
    "regionCode": "ME"
  },
  {
    "label": "country-BGD",
    "alpha3": "BGD",
    "name": "Bangladesh",
    "salesForceId": "Bangladesh"
  },
  {
    "label": "country-BRB",
    "alpha3": "BRB",
    "name": "Barbados",
    "salesForceId": "Barbados",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-BLR",
    "alpha3": "BLR",
    "name": "Belarus",
    "salesForceId": "Belarus",
    "frontline": "kdi-distributors",
    "regionCode": "EU"
  },
  {
    "label": "country-BEL",
    "alpha3": "BEL",
    "name": "Belgium",
    "salesForceId": "Belgium",
    "regionCode": "EU"
  },
  {
    "label": "country-BLZ",
    "alpha3": "BLZ",
    "name": "Belize",
    "salesForceId": "Belize"
  },
  {
    "label": "country-BEN",
    "alpha3": "BEN",
    "name": "Benin",
    "salesForceId": "Benin",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-BTN",
    "alpha3": "BTN",
    "name": "Bhutan",
    "salesForceId": "Bhutan"
  },
  {
    "label": "country-BOL",
    "alpha3": "BOL",
    "name": "Bolivia",
    "salesForceId": "Bolivia",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-BIH",
    "alpha3": "BIH",
    "name": "Bosnia and Herzegovina",
    "salesForceId": "Bosnia-Herz.",
    "regionCode": "EU"
  },
  {
    "label": "country-BWA",
    "alpha3": "BWA",
    "name": "Botswana",
    "salesForceId": "Botswana"
  },
  {
    "label": "country-BRA",
    "alpha3": "BRA",
    "name": "Brazil",
    "salesForceId": "Brazil",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-BRN",
    "alpha3": "BRN",
    "name": "Brunei",
    "salesForceId": "Brunei"
  },
  {
    "label": "country-BGR",
    "alpha3": "BGR",
    "name": "Bulgaria",
    "salesForceId": "Bulgaria",
    "regionCode": "EU"
  },
  {
    "label": "country-BFA",
    "alpha3": "BFA",
    "name": "Burkina-Faso",
    "salesForceId": "Burkina-Faso",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-BDI",
    "alpha3": "BDI",
    "name": "Burundi",
    "salesForceId": "Burundi",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-CPV",
    "alpha3": "CPV",
    "name": "Cape Verde",
    "salesForceId": "Cape Verde",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-KHM",
    "alpha3": "KHM",
    "name": "Cambodia",
    "salesForceId": "Cambodia"
  },
  {
    "label": "country-CMR",
    "alpha3": "CMR",
    "name": "Cameroon",
    "salesForceId": "Cameroon",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-CAN",
    "alpha3": "CAN",
    "name": "Canada",
    "salesForceId": "Canada",
    "regionCode": "NA"
  },
  {
    "label": "country-CAF",
    "alpha3": "CAF",
    "name": "Central African Republic",
    "salesForceId": "Central Afr.Rep",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-TCD",
    "alpha3": "TCD",
    "name": "Chad",
    "salesForceId": "Chad"
  },
  {
    "label": "country-CHL",
    "alpha3": "CHL",
    "name": "Chile",
    "salesForceId": "Chile",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-CHN",
    "alpha3": "CHN",
    "name": "China",
    "salesForceId": "China",
    "regionCode": "AS"
  },
  {
    "label": "country-COL",
    "alpha3": "COL",
    "name": "Colombia",
    "salesForceId": "Colombia",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-COM",
    "alpha3": "COM",
    "name": "Comoros",
    "salesForceId": "Comoros"
  },
  {
    "label": "country-COG",
    "alpha3": "COG",
    "name": "Congo",
    "salesForceId": "Congo",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-CRI",
    "alpha3": "CRI",
    "name": "Costa Rica",
    "salesForceId": "Costa Rica",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-HRV",
    "alpha3": "HRV",
    "name": "Croatia",
    "salesForceId": "Croatia",
    "regionCode": "EU"
  },
  {
    "label": "country-CUB",
    "alpha3": "CUB",
    "name": "Cuba",
    "salesForceId": "Cuba",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-CYP",
    "alpha3": "CYP",
    "name": "Cyprus",
    "salesForceId": "Cyprus",
    "regionCode": "EU"
  },
  {
    "label": "country-CZE",
    "alpha3": "CZE",
    "name": "Czech Republic",
    "salesForceId": "Czech Republic",
    "regionCode": "EU"
  },
  {
    "label": "country-DNK",
    "alpha3": "DNK",
    "name": "Denmark",
    "salesForceId": "Denmark",
    "regionCode": "EU"
  },
  {
    "label": "country-DJI",
    "alpha3": "DJI",
    "name": "Djibouti",
    "salesForceId": "Djibouti",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-DMA",
    "alpha3": "DMA",
    "name": "Dominica",
    "salesForceId": "Dominica",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-DOM",
    "alpha3": "DOM",
    "name": "Dominican Republic",
    "salesForceId": "Dominican Rep.",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-ECU",
    "alpha3": "ECU",
    "name": "Ecuador",
    "salesForceId": "Ecuador",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-EGY",
    "alpha3": "EGY",
    "name": "Egypt",
    "salesForceId": "Egypt",
    "regionCode": "ME"
  },
  {
    "label": "country-SLV",
    "alpha3": "SLV",
    "name": "El Salvador",
    "salesForceId": "El Salvador",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-GNQ",
    "alpha3": "GNQ",
    "name": "Equatorial Guinea",
    "salesForceId": "Equatorial Guin",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-ERI",
    "alpha3": "ERI",
    "name": "Eritrea",
    "salesForceId": "Eritrea",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-EST",
    "alpha3": "EST",
    "name": "Estonia",
    "salesForceId": "Estonia",
    "regionCode": "EU"
  },
  {
    "label": "country-ETH",
    "alpha3": "ETH",
    "name": "Ethiopia",
    "salesForceId": "Ethiopia",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-FJI",
    "alpha3": "FJI",
    "name": "Fiji",
    "salesForceId": "Fiji",
    "frontline": "kdi-distributors",
    "regionCode": "OC"
  },
  {
    "label": "country-FIN",
    "alpha3": "FIN",
    "name": "Finland",
    "salesForceId": "Finland",
    "regionCode": "EU"
  },
  {
    "label": "country-FRA",
    "alpha3": "FRA",
    "name": "France",
    "salesForceId": "France",
    "regionCode": "EU"
  },
  {
    "label": "country-GUF",
    "alpha3": "GUF",
    "name": "French Guiana",
    "salesForceId": "French Guiana",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-GAB",
    "alpha3": "GAB",
    "name": "Gabon",
    "salesForceId": "Gabon",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-GMB",
    "alpha3": "GMB",
    "name": "Gambia",
    "salesForceId": "Gambia",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-GEO",
    "alpha3": "GEO",
    "name": "Georgia",
    "salesForceId": "Georgia",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-DEU",
    "alpha3": "DEU",
    "name": "Germany",
    "salesForceId": "Germany",
    "regionCode": "EU"
  },
  {
    "label": "country-GHA",
    "alpha3": "GHA",
    "name": "Ghana",
    "salesForceId": "Ghana",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-GRC",
    "alpha3": "GRC",
    "name": "Greece",
    "salesForceId": "Greece",
    "regionCode": "EU"
  },
  {
    "label": "country-GRD",
    "alpha3": "GRD",
    "name": "Grenada",
    "salesForceId": "Grenada",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-GTM",
    "alpha3": "GTM",
    "name": "Guatemala",
    "salesForceId": "Guatemala",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-GIN",
    "alpha3": "GIN",
    "name": "Guinea",
    "salesForceId": "Guinea",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-GNB",
    "alpha3": "GNB",
    "name": "Guinea-Bissau",
    "salesForceId": "Guinea-Bissau",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-GUY",
    "alpha3": "GUY",
    "name": "Guyana",
    "salesForceId": "Guyana",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-HTI",
    "alpha3": "HTI",
    "name": "Haiti",
    "salesForceId": "Haiti",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-HND",
    "alpha3": "HND",
    "name": "Honduras",
    "salesForceId": "Honduras",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-HKG",
    "alpha3": "HKG",
    "name": "Hong Kong SAR",
    "salesForceId": "Hong Kong",
    "regionCode": "AS"
  },
  {
    "label": "country-HUN",
    "alpha3": "HUN",
    "name": "Hungary",
    "salesForceId": "Hungary",
    "regionCode": "EU"
  },
  {
    "label": "country-ISL",
    "alpha3": "ISL",
    "name": "Iceland",
    "salesForceId": "Iceland",
    "regionCode": "EU"
  },
  {
    "label": "country-IND",
    "alpha3": "IND",
    "name": "India",
    "salesForceId": "India",
    "regionCode": "AS"
  },
  {
    "label": "country-IDN",
    "alpha3": "IDN",
    "name": "Indonesia",
    "salesForceId": "Indonesia",
    "regionCode": "AS"
  },
  {
    "label": "country-IRN",
    "alpha3": "IRN",
    "name": "Iran",
    "salesForceId": "Iran"
  },
  {
    "label": "country-IRQ",
    "alpha3": "IRQ",
    "name": "Iraq",
    "salesForceId": "Iraq",
    "frontline": "kdi-distributors",
    "regionCode": "ME"
  },
  {
    "label": "country-IRL",
    "alpha3": "IRL",
    "name": "Ireland",
    "salesForceId": "Ireland",
    "regionCode": "EU"
  },
  {
    "label": "country-ISR",
    "alpha3": "ISR",
    "name": "Israel",
    "salesForceId": "Israel",
    "regionCode": "ME"
  },
  {
    "label": "country-ITA",
    "alpha3": "ITA",
    "name": "Italy",
    "salesForceId": "Italy",
    "regionCode": "EU"
  },
  {
    "label": "country-CIV",
    "alpha3": "CIV",
    "name": "Ivory Coast",
    "salesForceId": "Ivory Coast",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-JAM",
    "alpha3": "JAM",
    "name": "Jamaica",
    "salesForceId": "Jamaica",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-JPN",
    "alpha3": "JPN",
    "name": "Japan",
    "salesForceId": "Japan"
  },
  {
    "label": "country-JOR",
    "alpha3": "JOR",
    "name": "Jordan",
    "salesForceId": "Jordan",
    "frontline": "kdi-distributors",
    "regionCode": "ME"
  },
  {
    "label": "country-KAZ",
    "alpha3": "KAZ",
    "name": "Kazakhstan",
    "salesForceId": "Kazakhstan",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-KEN",
    "alpha3": "KEN",
    "name": "Kenya",
    "salesForceId": "Kenya",
    "regionCode": "AF"
  },
  {
    "label": "country-KIR",
    "alpha3": "KIR",
    "name": "Kiribati",
    "salesForceId": "Kiribati"
  },
  {
    "label": "country-PRK",
    "alpha3": "PRK",
    "name": "Korea North",
    "salesForceId": "North Korea"
  },
  {
    "label": "country-KOR",
    "alpha3": "KOR",
    "name": "Korea South",
    "salesForceId": "South Korea"
  },
  {
    "label": "country-XXR",
    "alpha3": "XXR",
    "name": "Kosovo",
    "salesForceId": "Kosovo",
    "frontline": "kdi-distributors",
    "regionCode": "EU"
  },
  {
    "label": "country-KWT",
    "alpha3": "KWT",
    "name": "Kuwait",
    "salesForceId": "Kuwait",
    "frontline": "kdi-distributors",
    "regionCode": "ME"
  },
  {
    "label": "country-KGZ",
    "alpha3": "KGZ",
    "name": "Kyrgyzstan",
    "salesForceId": "Kyrgyzstan",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-LAO",
    "alpha3": "LAO",
    "name": "Laos",
    "salesForceId": "Laos"
  },
  {
    "label": "country-LVA",
    "alpha3": "LVA",
    "name": "Latvia",
    "salesForceId": "Latvia",
    "regionCode": "EU"
  },
  {
    "label": "country-LBN",
    "alpha3": "LBN",
    "name": "Lebanon",
    "salesForceId": "Lebanon",
    "frontline": "kdi-distributors",
    "regionCode": "ME"
  },
  {
    "label": "country-LSO",
    "alpha3": "LSO",
    "name": "Lesotho",
    "salesForceId": "Lesotho"
  },
  {
    "label": "country-LBR",
    "alpha3": "LBR",
    "name": "Liberia",
    "salesForceId": "Liberia",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-LBY",
    "alpha3": "LBY",
    "name": "Libya",
    "salesForceId": "Libya",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-LIE",
    "alpha3": "LIE",
    "name": "Liechtenstein",
    "salesForceId": "Liechtenstein"
  },
  {
    "label": "country-LTU",
    "alpha3": "LTU",
    "name": "Lithuania",
    "salesForceId": "Lithuania",
    "regionCode": "EU"
  },
  {
    "label": "country-LUX",
    "alpha3": "LUX",
    "name": "Luxembourg",
    "salesForceId": "Luxembourg"
  },
  {
    "label": "country-MDG",
    "alpha3": "MDG",
    "name": "Madagascar",
    "salesForceId": "Madagascar",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-MWI",
    "alpha3": "MWI",
    "name": "Malawi",
    "salesForceId": "Malawi",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-MYS",
    "alpha3": "MYS",
    "name": "Malaysia",
    "salesForceId": "Malaysia",
    "regionCode": "AS"
  },
  {
    "label": "country-MDV",
    "alpha3": "MDV",
    "name": "Maldives",
    "salesForceId": "Maldives",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-MLI",
    "alpha3": "MLI",
    "name": "Mali",
    "salesForceId": "Mali",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-MLT",
    "alpha3": "MLT",
    "name": "Malta",
    "salesForceId": "Malta",
    "frontline": "kdi-distributors",
    "regionCode": "EU"
  },
  {
    "label": "country-MHL",
    "alpha3": "MHL",
    "name": "Marshall Islands",
    "salesForceId": "Marshall Islnds"
  },
  {
    "label": "country-MTQ",
    "alpha3": "MTQ",
    "name": "Martinique",
    "salesForceId": "Martinique",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-MRT",
    "alpha3": "MRT",
    "name": "Mauritania",
    "salesForceId": "Mauretania",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-MUS",
    "alpha3": "MUS",
    "name": "Mauritius",
    "salesForceId": "Mauritius",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-MEX",
    "alpha3": "MEX",
    "name": "Mexico",
    "salesForceId": "Mexico",
    "regionCode": "NA"
  },
  {
    "label": "country-FSM",
    "alpha3": "FSM",
    "name": "Micronesia",
    "salesForceId": "Micronesia"
  },
  {
    "label": "country-MDA",
    "alpha3": "MDA",
    "name": "Moldova",
    "salesForceId": "Moldova"
  },
  {
    "label": "country-MCO",
    "alpha3": "MCO",
    "name": "Monaco",
    "salesForceId": "Monaco"
  },
  {
    "label": "country-MNG",
    "alpha3": "MNG",
    "name": "Mongolia",
    "salesForceId": "Mongolia",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-MNE",
    "alpha3": "MNE",
    "name": "Montenegro",
    "salesForceId": "Montenegro",
    "regionCode": "EU"
  },
  {
    "label": "country-MSR",
    "alpha3": "MSR",
    "name": "Montserrat",
    "salesForceId": "Montserrat",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-MAR",
    "alpha3": "MAR",
    "name": "Morocco",
    "salesForceId": "Morocco",
    "regionCode": "AF"
  },
  {
    "label": "country-MOZ",
    "alpha3": "MOZ",
    "name": "Mozambique",
    "salesForceId": "Mozambique",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-MMR",
    "alpha3": "MMR",
    "name": "Myanmar (Burma)",
    "salesForceId": "Myanmar"
  },
  {
    "label": "country-NAM",
    "alpha3": "NAM",
    "name": "Namibia",
    "salesForceId": "Namibia",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-NRU",
    "alpha3": "NRU",
    "name": "Nauru",
    "salesForceId": "Nauru"
  },
  {
    "label": "country-NPL",
    "alpha3": "NPL",
    "name": "Nepal",
    "salesForceId": "Nepal"
  },
  {
    "label": "country-NLD",
    "alpha3": "NLD",
    "name": "Netherlands",
    "salesForceId": "Netherlands",
    "regionCode": "EU"
  },
  {
    "label": "country-NCL",
    "alpha3": "NCL",
    "name": "New Caledonia",
    "salesForceId": "New Caledonia"
  },
  {
    "label": "country-NZL",
    "alpha3": "NZL",
    "name": "New Zealand",
    "salesForceId": "New Zealand",
    "regionCode": "OC"
  },
  {
    "label": "country-NIC",
    "alpha3": "NIC",
    "name": "Nicaragua",
    "salesForceId": "Nicaragua",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-NER",
    "alpha3": "NER",
    "name": "Niger",
    "salesForceId": "Niger",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-NGA",
    "alpha3": "NGA",
    "name": "Nigeria",
    "salesForceId": "Nigeria",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-NOR",
    "alpha3": "NOR",
    "name": "Norway",
    "salesForceId": "Norway",
    "regionCode": "EU"
  },
  {
    "label": "country-OMN",
    "alpha3": "OMN",
    "name": "Oman",
    "salesForceId": "Oman",
    "regionCode": "ME"
  },
  {
    "label": "country-PAK",
    "alpha3": "PAK",
    "name": "Pakistan",
    "salesForceId": "Pakistan",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-PLW",
    "alpha3": "PLW",
    "name": "Palau",
    "salesForceId": "Palau"
  },
  {
    "label": "country-PAN",
    "alpha3": "PAN",
    "name": "Panama",
    "salesForceId": "Panama",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-PNG",
    "alpha3": "PNG",
    "name": "Papua New Guinea",
    "salesForceId": "Papua Nw Guinea"
  },
  {
    "label": "country-PRY",
    "alpha3": "PRY",
    "name": "Paraguay",
    "salesForceId": "Paraguay",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-PER",
    "alpha3": "PER",
    "name": "Peru",
    "salesForceId": "Peru",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-PHL",
    "alpha3": "PHL",
    "name": "Philippines",
    "salesForceId": "Philippines",
    "regionCode": "AS"
  },
  {
    "label": "country-POL",
    "alpha3": "POL",
    "name": "Poland",
    "salesForceId": "Poland",
    "regionCode": "EU"
  },
  {
    "label": "country-PRT",
    "alpha3": "PRT",
    "name": "Portugal",
    "salesForceId": "Portugal",
    "regionCode": "EU"
  },
  {
    "label": "country-QAT",
    "alpha3": "QAT",
    "name": "Qatar",
    "salesForceId": "Qatar",
    "regionCode": "ME"
  },
  {
    "label": "country-MKD",
    "alpha3": "MKD",
    "name": "North Macedonia",
    "salesForceId": "Macedonia",
    "regionCode": "EU"
  },
  {
    "label": "country-ROU",
    "alpha3": "ROU",
    "name": "Romania",
    "salesForceId": "Romania",
    "regionCode": "EU"
  },
  {
    "label": "country-RUS",
    "alpha3": "RUS",
    "name": "Russia",
    "salesForceId": "Russian Fed.",
    "regionCode": "EU"
  },
  {
    "label": "country-RWA",
    "alpha3": "RWA",
    "name": "Rwanda",
    "salesForceId": "Rwanda",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-KNA",
    "alpha3": "KNA",
    "name": "St. Kitts and Nevis",
    "salesForceId": "St.Chr.,Nevis",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-LCA",
    "alpha3": "LCA",
    "name": "St. Lucia",
    "salesForceId": "St. Lucia",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-VCT",
    "alpha3": "VCT",
    "name": "Saint Vincent and the Grenadines",
    "salesForceId": "St. Vincent",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-WSM",
    "alpha3": "WSM",
    "name": "Samoa",
    "salesForceId": "Samoa"
  },
  {
    "label": "country-SMR",
    "alpha3": "SMR",
    "name": "San Marino",
    "salesForceId": "San Marino"
  },
  {
    "label": "country-STP",
    "alpha3": "STP",
    "name": "Sao Tome and Principe",
    "salesForceId": "S.Tome,Principe"
  },
  {
    "label": "country-SAU",
    "alpha3": "SAU",
    "name": "Saudi Arabia",
    "salesForceId": "Saudi Arabia",
    "regionCode": "ME"
  },
  {
    "label": "country-SEN",
    "alpha3": "SEN",
    "name": "Senegal",
    "salesForceId": "Senegal",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-SRB",
    "alpha3": "SRB",
    "name": "Serbia",
    "salesForceId": "Serbia",
    "regionCode": "EU"
  },
  {
    "label": "country-SYC",
    "alpha3": "SYC",
    "name": "Seychelles",
    "salesForceId": "Seychelles",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-SLE",
    "alpha3": "SLE",
    "name": "Sierra Leone",
    "salesForceId": "Sierra Leone",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-SGP",
    "alpha3": "SGP",
    "name": "Singapore",
    "salesForceId": "Singapore",
    "regionCode": "AS"
  },
  {
    "label": "country-SVK",
    "alpha3": "SVK",
    "name": "Slovakia",
    "salesForceId": "Slovakia",
    "regionCode": "EU"
  },
  {
    "label": "country-SVN",
    "alpha3": "SVN",
    "name": "Slovenia",
    "salesForceId": "Slovenia",
    "regionCode": "EU"
  },
  {
    "label": "country-SLB",
    "alpha3": "SLB",
    "name": "Solomon Islands",
    "salesForceId": "Solomon Islands"
  },
  {
    "label": "country-SOM",
    "alpha3": "SOM",
    "name": "Somalia",
    "salesForceId": "Somalia"
  },
  {
    "label": "country-ZAF",
    "alpha3": "ZAF",
    "name": "South Africa",
    "salesForceId": "South Africa",
    "regionCode": "AF"
  },
  {
    "label": "country-SSD",
    "alpha3": "SSD",
    "name": "South Sudan",
    "salesForceId": "Sudan"
  },
  {
    "label": "country-ESP",
    "alpha3": "ESP",
    "name": "Spain",
    "salesForceId": "Spain",
    "regionCode": "EU"
  },
  {
    "label": "country-LKA",
    "alpha3": "LKA",
    "name": "Sri Lanka",
    "salesForceId": "Sri Lanka"
  },
  {
    "label": "country-SDN",
    "alpha3": "SDN",
    "name": "Sudan",
    "salesForceId": "Sudan",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-SUR",
    "alpha3": "SUR",
    "name": "Suriname",
    "salesForceId": "Suriname",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-SWZ",
    "alpha3": "SWZ",
    "name": "Swaziland",
    "salesForceId": "Swaziland"
  },
  {
    "label": "country-SWE",
    "alpha3": "SWE",
    "name": "Sweden",
    "salesForceId": "Sweden",
    "regionCode": "EU"
  },
  {
    "label": "country-CHE",
    "alpha3": "CHE",
    "name": "Switzerland",
    "salesForceId": "Switzerland",
    "regionCode": "EU"
  },
  {
    "label": "country-SYR",
    "alpha3": "SYR",
    "name": "Syria",
    "salesForceId": "Syria",
    "frontline": "kdi-distributors",
    "regionCode": "ME"
  },
  {
    "label": "country-TWN",
    "alpha3": "TWN",
    "name": "Taiwan, China",
    "salesForceId": "Taiwan",
    "regionCode": "AS"
  },
  {
    "label": "country-TJK",
    "alpha3": "TJK",
    "name": "Tajikistan",
    "salesForceId": "Tajikistan",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-TZA",
    "alpha3": "TZA",
    "name": "Tanzania",
    "salesForceId": "Tanzania",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-THA",
    "alpha3": "THA",
    "name": "Thailand",
    "salesForceId": "Thailand",
    "regionCode": "AS"
  },
  {
    "label": "country-TLS",
    "alpha3": "TLS",
    "name": "East Timor",
    "salesForceId": "East Timor"
  },
  {
    "label": "country-TGO",
    "alpha3": "TGO",
    "name": "Togo",
    "salesForceId": "Togo",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-TON",
    "alpha3": "TON",
    "name": "Tonga",
    "salesForceId": "Tonga"
  },
  {
    "label": "country-TTO",
    "alpha3": "TTO",
    "name": "Trinidad and Tobago",
    "salesForceId": "Trinidad,Tobago",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-TUN",
    "alpha3": "TUN",
    "name": "Tunisia",
    "salesForceId": "Tunisia",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-TUR",
    "alpha3": "TUR",
    "name": "Turkey",
    "salesForceId": "Turkey",
    "regionCode": "ME"
  },
  {
    "label": "country-TKM",
    "alpha3": "TKM",
    "name": "Turkmenistan",
    "salesForceId": "Turkmenistan",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-TCA",
    "alpha3": "TCA",
    "name": "Turks and Caicos Islands",
    "salesForceId": "Turksh Caicosin",
    "frontline": "latin-america-distributors",
    "regionCode": "NA"
  },
  {
    "label": "country-TUV",
    "alpha3": "TUV",
    "name": "Tuvalu",
    "salesForceId": "Tuvalu"
  },
  {
    "label": "country-UGA",
    "alpha3": "UGA",
    "name": "Uganda",
    "salesForceId": "Uganda",
    "regionCode": "AF"
  },
  {
    "label": "country-UKR",
    "alpha3": "UKR",
    "name": "Ukraine",
    "salesForceId": "Ukraine",
    "regionCode": "EU"
  },
  {
    "label": "country-ARE",
    "alpha3": "ARE",
    "name": "United Arab Emirates",
    "salesForceId": "UAE",
    "regionCode": "ME"
  },
  {
    "label": "country-GBR",
    "alpha3": "GBR",
    "name": "United Kingdom",
    "salesForceId": "Great Britain",
    "regionCode": "EU"
  },
  {
    "label": "country-USA",
    "alpha3": "USA",
    "name": "United States",
    "salesForceId": "USA",
    "regionCode": "NA"
  },
  {
    "label": "country-URY",
    "alpha3": "URY",
    "name": "Uruguay",
    "salesForceId": "Uruguay",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-UZB",
    "alpha3": "UZB",
    "name": "Uzbekistan",
    "salesForceId": "Uzbekistan",
    "frontline": "kdi-distributors",
    "regionCode": "AS"
  },
  {
    "label": "country-VUT",
    "alpha3": "VUT",
    "name": "Vanuatu",
    "salesForceId": "Vanuatu"
  },
  {
    "label": "country-VAT",
    "alpha3": "VAT",
    "name": "Vatican City",
    "salesForceId": "Vatican City"
  },
  {
    "label": "country-VEN",
    "alpha3": "VEN",
    "name": "Venezuela",
    "salesForceId": "Venezuela",
    "frontline": "latin-america-distributors",
    "regionCode": "SA"
  },
  {
    "label": "country-VNM",
    "alpha3": "VNM",
    "name": "Vietnam",
    "salesForceId": "Vietnam",
    "regionCode": "AS"
  },
  {
    "label": "country-YEM",
    "alpha3": "YEM",
    "name": "Yemen",
    "salesForceId": "Yemen",
    "frontline": "kdi-distributors",
    "regionCode": "ME"
  },
  {
    "label": "country-ZMB",
    "alpha3": "ZMB",
    "name": "Zambia",
    "salesForceId": "Zambia",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  },
  {
    "label": "country-ZWE",
    "alpha3": "ZWE",
    "name": "Zimbabwe",
    "salesForceId": "Zimbabwe",
    "frontline": "kdi-distributors",
    "regionCode": "AF"
  }
]